(() => {
  const containers = document.querySelectorAll('[data-product-recommendations]');
  if (!containers.length) return;

  containers.forEach(async (container) => {
    const url = container.dataset.url;
    if (!url) return;
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-product-recommendations]');
      if (fresh) container.innerHTML = fresh.innerHTML;
    } catch (err) {
      console.error('Recommendations load failed', err);
    }
  });
})();
